export const URL = {
    LEARN: "learn",
    MAINTENANCE: "maintenance",
    PRIVACY_POLICY: "privacy-policy",
    DISCLAIMER: "disclaimer",
    TERMS_AND_CONDITIONS: "terms-and-conditions",
    MY_ACCOUNT: "my-account",
    OUR_PRODUCTS: 'our-products',
    FAVORITES: 'my-favourites',
    CAREERS: 'careers',
    INFORMATION: 'information',
    NAV_DIVIDEND: 'nav-and-idcw',
    LATEST_NAV: 'latest-navs-and-idcw',
    CONTACT_US: 'contact-us',
    SUBSCRIBE: 'subscription',
    VALIDATE: 'validate',
    CONTENTID: '?contentId',
    QUESTION: '?',
    TOKEN: 'token',
    SCHEMES: 'schemes',
    SITEMAP: 'sitemap',
    GOLD_CASH_COMPONENT: 'gold-cash-component',
    SILVER_CASH_COMPONENT: 'silver-cash-component',
    CREATION_COMPONENT: 'creation-component',
    REBALANCING: 'rebalancing',
    COOKIE_POLICY: 'information/cookie-policy',
    // WHATSAPP_SERVICE: 'whats-app-service',
    WEALTH_CREATION: 'wealth-creation',
    INCOME_SOLUTIONS: 'income-solutions',
    TAX_SAVING: 'tax-savings',
    RETIREMENT_PLANNING: 'retirement-planning',
    CHILDREN_FUND: 'children-fund',
    RETIREMENT_FUND: 'retirement-fund',
    CAT_DIVERSE: 'diversified-equity',
    CAT_INDEX: 'index',
    CAT_ETF: 'etf',
    CAT_NFO: 'nfo',
    CAT_HYBRID: 'hybrid',
    CAT_GOLD_ETF: 'gold-etf/fof',
    CAT_THEME_BASED: 'theme-based-debt',
    CAT_ELSS: 'equity-linked-savings-scheme-elss',
    CAT_THEMATIC_EQ: 'thematic-equity',
    CAT_SOLUTION_ORIENTED: 'solution-oriented',
    CAT_DURATION_BASED: 'duration-based-debt',
    CAT_FUND_OF_FUNDS: 'fund-of-funds',
    CAT_THEMATIC_SECTORAL_EQUITY: 'thematic/sectoral-equity',
    UPDATES_NOTIFICATION: 'notification',
    MF_BYTES: 'mf-bytes',
    WRITE_TO_US: 'write-to-us',
    MD_DESK: 'message-from-MD-&-CEO',
    // Start About Us
    ABOUT_US_NEW: 'about-us',
    CORPORATE_PROFILE: 'corporate-profile',
    CORPORATE_GOVERNANCE: 'corporate-governance',
    FINANCIAL_INFORMATION: 'financial-information',
    MEDIA_CENTER: 'media-center',
    LEADERSHIP_PROFILE: 'our-board-and-trustees',
    // End About Us
    // Learners Corners Start
    LEARNERS_CORNERS: "learners-corner",
    LEARNERS_BEGINNER: "beginner",
    LEARNERS_INTERMEDIATE: "intermediate",
    LEARNERS_ADVANCED: "advanced",
    IAP_DOWNLOADS: "investor-awareness",
    LEARNERS_CORNERS_VIDEOS: "videos",
    LEARNERS_CORNERS_PODCAST: "podcast",
    LEARNERS_TOOLS: 'calculator',
    LEARNERS_CORNERS_IMPACT_INFLATIONS: "impact-of-inflation",
    LEARNERS_CORNERS_SIP_CALCULATOR: "sip-calculator",
    LEARNERS_CORNERS_PRESENT_VALUES: "present-value",
    LEARNERS_CORNERS_GOALSIP: "goal-sip",
    LEARNERS_CORNERS_TOPUPSIP: "top-up-sip",
    LEARNERS_CORNERS_STPCALCULATOR: "stp-calculator",
    LEARNERS_CORNERS_SWAPCALCULATOR: "swap-calculator",
    LEARNERS_CORNERS_RETIREMENTCALCULATOR: "retirement-calculator",
    LEARNERS_CORNERS_COSTOFCHILDEDUCATION: "cost-of-child-education",
    LEARNERS_CORNERS_DREAMSIP: "dream-sip",
    LEARNERS_CORNERS_BOOK_REVIEW: "book-review-zone",
    THE_READING_ROOM: "the-reading-room",
    THE_POETRYSEC_SEC: "poetry-lounge",
    // Learners Corners End
    // Start Product Solution
    PRODUCT_SOLUTIONS: "product-solutions",
    COMPAREFUNDS: "compare-funds",
    COMPAREFUNDSDETAILS: "comparefunds-details",
    PRODUCT_OVERVIEW: "overview",
    NFO_OVERVIEW: "nfo-overview",
    FLEXI_CAP_PROMOTION: "hdfc-flexi-cap-fund-smartlink",
    FLEXI_CAP_PROMOTION_QUICK_LINK: "hdfc-flexi-cap-fund-quicklink",
    // End Product Solution

    //StatutoryDisclosure start
    STATUTORY_DISCLOSURE: "statutory-disclosure",
    MANDATORY_INVESTMENT_AMC: "mandatory-investment-amc",
    DISCLOSURE_OF_VARIOUS_PAYMENT: "disclosure-of-various-payment",
    DISCLOSURE_OF_DESIGNATED_EMPLOYEES: "disclosure-of-designated-employees",
    DISCLOSURE_OF_VARIOUS_PURPOSE: "disclosure-of-various-purpose",
    REPORT_OF_COMPLIANCE_STEWARDSHIP_CODE:
        "report-of-compliance-of-stewardship-code",
    RATIONAL_FOR_DEVIATION: "details-deviations-valuation-price-provided-valuation-agencies",
    ANNUAL_DISCLOSURE_OF_RISKOMETERS: "riskometers",
    ANNUAL_REPORT: "annual-reports",
    ABRIDGED: "abridged",
    SCHEME_FINANCIALS: "scheme-financials",
    MONTHLY_PORTFOLIO: "portfolio",
    AVERAGE_PORTFOLIO: "average-portfolio",
    AUM: "aum",
    TRADE: "trade",
    COMISSION: "commission",
    STAT_UNCLAIMED_DIVIDEND_REDEMPTION: "unclaimed-dividend-and-redemption",
    TOTAL_EXPENSE_RATIO_OF_MUTUAL_FUND_SCHEMES:
        "total-expense-ratio-of-mutual-fund-schemes",
    STAT_TRACKING_ERROR: "tracking-error",
    VOTING: "voting",
    STEWARDSHIP_REPORT: "stewardship-report",
    REMUNERATION_NEW: 'remuneration',
    SCHEME_PERFORMANCE_NEW: 'scheme-performance',
    INVESTOR_COMPLAINTS: 'data-on-investor-complaints',
    INVESTOR_COMPLAINTS_PMS: 'investor-complaints-pms',
    STATUTORY_COMPLAINTS: 'complaints',
    LETTER_UNITHOLDER: 'letter-unitholder',
    STAT_PUBLIC_CAUTION_NOTICE: "public-caution-notice",
    OFFER_DOCUMENT: "offer-document-disclosures",
    ADVISORY_DISCLOSURE: "statutory-disclosure-hdfc-mid-cap-opportunities-fund-and-hdfc-small-cap-fund",
    DISTRIBUTOR_COMMISSION: "disclosure-on-distributor-related-expenses",
    MARKET_MAKERS: "market-makers-authorized-participants",
    DISCLOSURENEW: "disclosure-of-issuerwise-groupwise-sectorwise-exposure-for-etf-index-funds",
    RISK_ADJUSTED_RETURN: "information-ratio-disclosure-for-equity-mutual-funds",
    REPORT_ON_MISSELLING: "report-misselling",
    //StatutoryDisclosure end
    //Distributor Corner Start
    DISTRIBUTOR_CORNER: "distributor-corner",
    BEING_A_MFD: "being-a-mfd",
    ONBOARD_DIGITALLY: "onboard-digitally",
    FORMS_DISCLOSURE: "forms-disclosure",
    KNOWLEDGE_CENTER: "knowledge-center",
    FAQS: "faqs",
    SEBI_CODE_OF_CONDUCT: "sebi-code-of-conduct",
    HANDBOOK: "handbook",
    //Distributor Corner end
    //Start Investor Services
    INVESTOR_SERVICES: "investor-services",
    FORM_AND_DISCLOSURES: "form-disclosures",
    OUR_ONLINE_SERVICES: "our-online-services",
    ADDITIONAL_FUND_INFO: "additional-fund-info",
    FACTSHEETS: "factsheets",
    FUND_DOCUMENTS: "fund-documents",
    FUND_LITERATURES: "fund-literature",
    INVESTOR_MARKET_UPDATE: "market-update",
    INVESTOR_FAQ: "investor-faq",
    SCHEME_COLLECTION: 'scheme-collection',
    WEEKLY_PORTFOLIO_DETAILS: "weekly-debt-and-portfolio-details",
    //End Investor SErvices

    //Knowledge Stack start
    KNOWLEDGE_STACK: "knowledge-stack",
    NEW_MD_INSIGHTS: "md-ceo-desk",
    // MD_SPEAKS_ARTICLES: "md-speaks/articles",
    // MD_SPEAKS_VIDEOS: "md-speaks/videos",
    // MD_MEDIA_ARTICLES: "media/interview",
    // MD_MEDIA_VIDEOS: "media/video",
    MARKET_REVIEW: "macro-insights/market-review",
    CREDIT_POLICY: "macro-insights/monetary-policy-review",
    MF_YEARBOOK: "macro-insights/hdfc-mf-yearbook",
    TUESDAYS_TALKING_POINTS: "deep-dives/tuesdays-talking-points",
    CHART_SCOPE: "deep-dives/chartscope",
    MF_INSIGHTS: "deep-dives/hdfc-mf-insights",
    WEEKEND_BYTES: "mf-vault/weekend-bytes",
    MUSINGS: "mf-vault/musings",
    WEBINARS: "interactive-media/webinar",
    VIDEOS_MEDIA: "interactive-media/videos",
    PODCASTS_MEDIA: "interactive-media/podcasts",
    BEHAVIOURAL_BLOGS: "behavioural-blogs",
    //Knowledge Stack end
    //goal marketing start
    GOAL_MARKETING: "goal",
    //goal marketing end

    HOMEPAGE: 'homepage',
    GOALS: 'goal-planning',
    KNOW_YOUR_INVESTMENT_PERSONALITY: 'know-your-investment-personality',
    INVESTMENT_BASKET: "investment-basket",
    ACCOUNT_STATEMENT: 'account-statement',
    SIP_LANDING: 'sip',
    GLOSSARY_SEC: "glossary",
    //IAP WOMEN start
    IAP_WOMEN_ENGLISH: 'sipsaheli',
    EMAIL_MODAL:"quiz-sipsaheli",
    IAP_REGISTRATION: 'registration',
    IAP_QUIZ_REGISTRATION: 'quiz',
    //IAP WOMEN end
    // Survey Start
    FINANCIAL_TRANSACTION: 'investors-ft-survey',
    NON_FINANCIAL_TRANSACTION: 'investors-nft-survey',  
    PARTNER_SURVEY: 'partners-survey',
    // Survey End
    // Jan Nivesh Start
    JAN_NIVESH: 'chhotisip',
    // Jan Nivesh End
    // Important Announcement start
    IMMPORTANT_ANNOUNCEMENT: 'important-announcement',
    // Important Announcement end
    //youtubeshorts start
    YOUTUBE_SHORTS: 'mutual-fund-shorts',
    //youtubeshorts end
    //OneSpan start
    ONESPAN: 'RASP/info',
    ONESPANIOS: 'RASPIOS/info'
    //OneSpan end
};

export default {
    DEFAULT: `/`,
    LEARN: `/${URL.LEARN}`,
    MAINTENANCE: `/${URL.MAINTENANCE}`,
    PRIVACY_POLICY: `/${URL.PRIVACY_POLICY}`,
    TERMS_AND_CONDITIONS: `/${URL.TERMS_AND_CONDITIONS}`,
    DISCLAIMER: `/${URL.DISCLAIMER}`,
    MY_ACCOUNT: `/${URL.MY_ACCOUNT}`,
    OUR_PRODUCTS: `/${URL.OUR_PRODUCTS}`,
    FAVORITES: `/${URL.FAVORITES}`,
    GOLD_CASH_COMPONENT: `/${URL.PRODUCT_SOLUTIONS}/creation-component/${URL.GOLD_CASH_COMPONENT}`,
    SILVER_CASH_COMPONENT: `/${URL.PRODUCT_SOLUTIONS}/creation-component/${URL.SILVER_CASH_COMPONENT}`,
    CALCULATE_CREATION_COMPONENT: `/${URL.CREATION_COMPONENT}/:creationType/:productName`,
    REBALANCING_COMPONENT: `/${URL.REBALANCING}/:creationType/:productName`,
    CAREERS: `/${URL.CAREERS}`,
    CONTACT_US: `/${URL.CONTACT_US}`,
    INFORMATION: `/information/:informationType`,
    BEGINNERINFO: '/learners-corner/beginner/:informationType',
    INTERMEDIATEINFO: '/learners-corner/intermediate/:informationType',
    ADVANCEINFO: '/learners-corner/advanced/:informationType',
    BOOK_REVIEW_INFO: '/learners-corner/the-reading-room/book-review-zone/:informationType',
    NAV_AND_DIVIDEND: `/${URL.NAV_DIVIDEND}/${URL.LATEST_NAV}`,
    SITEMAP: `/${URL.SITEMAP}`,
    PRODUCTSUBSCRIBEVALIDATE: `/subscribe/${URL.VALIDATE}`,
    SUBSCRIBEVALIDATE: `/${URL.SUBSCRIBE}/${URL.VALIDATE}`,
    REMOVE_SUBSCRIBE_VALIDATE: `/${URL.SUBSCRIBE}/remove/nav`,
    PAGE_NOT_FOUND: `*`,
    COOKIE_POLICY: `/${URL.COOKIE_POLICY}`,
    // WHATSAPP_SERVICE: `/${URL.WHATSAPP_SERVICE}`,
    MF_BYTES: `/${URL.MF_BYTES}`,

    WEALTH_CREATION: `/${URL.PRODUCT_SOLUTIONS}/${URL.WEALTH_CREATION}`,
    INCOME_SOLUTIONS: `/${URL.PRODUCT_SOLUTIONS}/${URL.INCOME_SOLUTIONS}`,
    TAX_SAVING: `/${URL.PRODUCT_SOLUTIONS}/${URL.TAX_SAVING}`,
    RETIREMENT_PLANNING: `/${URL.PRODUCT_SOLUTIONS}/${URL.RETIREMENT_PLANNING}`,
    CHILDREN_FUND: `/${URL.PRODUCT_SOLUTIONS}/${URL.CHILDREN_FUND}`,
    RETIREMENT_FUND: `/${URL.PRODUCT_SOLUTIONS}/${URL.RETIREMENT_FUND}`,

    CAT_DIVERSE: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_DIVERSE}`,
    CAT_THEMATIC_EQ: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_THEMATIC_EQ}`,
    CAT_ELSS: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_ELSS}`,
    CAT_THEME_BASED: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_THEME_BASED}`,
    CAT_SOLUTION_ORIENTED: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_SOLUTION_ORIENTED}`,
    CAT_INDEX: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_INDEX}`,
    CAT_ETF: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_ETF}`,
    CAT_NFO: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_NFO}`,
    CAT_HYBRID: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_HYBRID}`,
    CAT_GOLD_ETF: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_GOLD_ETF}`,
    CAT_DURATION_BASED: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_DURATION_BASED}`,
    CAT_FUND_OF_FUNDS: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_FUND_OF_FUNDS}`,
    CAT_THEMATIC_SECTORAL_EQUITY: `/${URL.PRODUCT_SOLUTIONS}/${URL.CAT_THEMATIC_SECTORAL_EQUITY}`,

    PRODUCT_SCHEME: `/${URL.OUR_PRODUCTS}/:productType`,
    UPDATES_NOTIFICATION: `/${URL.UPDATES_NOTIFICATION}`,
    WRITE_TO_US: `/${URL.WRITE_TO_US}`,
    // Start About Us
    ABOUT_US_NEW: `/${URL.ABOUT_US_NEW}`,
    CORPORATE_PROFILE: `/${URL.ABOUT_US_NEW}/${URL.CORPORATE_PROFILE}`,
    CORPORATE_GOVERNANCE: `/${URL.ABOUT_US_NEW}/${URL.CORPORATE_GOVERNANCE}`,
    FINANCIAL_INFORMATION: `/${URL.ABOUT_US_NEW}/${URL.FINANCIAL_INFORMATION}`,
    MEDIA_CENTER: `/${URL.ABOUT_US_NEW}/${URL.MEDIA_CENTER}`,
    LEADERSHIP_PROFILE: `/${URL.ABOUT_US_NEW}/${URL.LEADERSHIP_PROFILE}`,
    // END About Us
    // Learners Corners Start
    LEARNERS_CORNERS: `/${URL.LEARNERS_CORNERS}`,
    LEARNERS_BEGINNER: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_BEGINNER}`,
    LEARNERS_INTERMEDIATE: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_INTERMEDIATE}`,
    LEARNERS_ADVANCED: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_ADVANCED}`,
    IAP_DOWNLOADS: `/${URL.LEARNERS_CORNERS}/${URL.IAP_DOWNLOADS}`,
    LEARNERS_CORNERS_VIDEOS: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_CORNERS_VIDEOS}`,
    LEARNERS_CORNERS_PODCAST: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_CORNERS_PODCAST}`,
    LEARNERS_TOOLS: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_TOOLS}`,
    LEARNERS_CORNERS_IMPACT_INFLATIONS: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_CORNERS_IMPACT_INFLATIONS}`,
    LEARNERS_CORNERS_SIP_CALCULATOR: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_CORNERS_SIP_CALCULATOR}`,
    LEARNERS_CORNERS_PRESENT_VALUES: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_CORNERS_PRESENT_VALUES}`,
    LEARNERS_CORNERS_GOALSIP: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_CORNERS_GOALSIP}`,
    LEARNERS_CORNERS_TOPUPSIP: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_CORNERS_TOPUPSIP}`,
    LEARNERS_CORNERS_STPCALCULATOR: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_CORNERS_STPCALCULATOR}`,
    LEARNERS_CORNERS_SWAPCALCULATOR: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_CORNERS_SWAPCALCULATOR}`,
    LEARNERS_CORNERS_RETIREMENTCALCULATOR: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_CORNERS_RETIREMENTCALCULATOR}`,
    LEARNERS_CORNERS_COSTOFCHILDEDUCATION: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_CORNERS_COSTOFCHILDEDUCATION}`,
    LEARNERS_CORNERS_DREAMSIP: `/${URL.LEARNERS_CORNERS}/${URL.LEARNERS_CORNERS_DREAMSIP}`,
    LEARNERS_CORNERS_BOOK_REVIEW: `/${URL.LEARNERS_CORNERS}/${URL.THE_READING_ROOM}/${URL.LEARNERS_CORNERS_BOOK_REVIEW}`,
    LEARNERS_CORNERS_VIDEOS_DETAILS: `/learners-corner/videos/:informationType`,
    THE_READING_ROOM: `/${URL.LEARNERS_CORNERS}/${URL.THE_READING_ROOM}`,
    THE_POETRYSEC_SEC: `/${URL.LEARNERS_CORNERS}/${URL.THE_READING_ROOM}/${URL.THE_POETRYSEC_SEC}`,
    // Learners Corners End

    // Start Product solutions
    PRODUCT_SOLUTIONS: `/${URL.PRODUCT_SOLUTIONS}`,
    COMPAREFUNDS: `/${URL.PRODUCT_SOLUTIONS}/${URL.COMPAREFUNDS}`,
    COMPAREFUNDSDETAILS: `/${URL.PRODUCT_SOLUTIONS}/${URL.COMPAREFUNDSDETAILS}`,
    FLEXI_CAP_PROMOTION :  `/${URL.PRODUCT_SOLUTIONS}/${URL.PRODUCT_OVERVIEW}/${URL.FLEXI_CAP_PROMOTION}`,
    FLEXI_CAP_PROMOTION_QUICK_LINK :  `/${URL.PRODUCT_SOLUTIONS}/${URL.PRODUCT_OVERVIEW}/${URL.FLEXI_CAP_PROMOTION_QUICK_LINK}`,
    PRODUCT_OVERVIEW: `/product-solutions/overview/:fundtype/:plantype`,
    NFO_OVERVIEW: `/product-solutions/nfo-overview/:fundtype/:plantype`,
    //ENd Product solutions
    //StatutoryDisclosure start
    STATUTORY_DISCLOSURE: `/${URL.STATUTORY_DISCLOSURE}`,
    MANDATORY_INVESTMENT_AMC: `/${URL.STATUTORY_DISCLOSURE}/${URL.MANDATORY_INVESTMENT_AMC}`,
    DISCLOSURE_OF_VARIOUS_PAYMENT: `/${URL.STATUTORY_DISCLOSURE}/${URL.DISCLOSURE_OF_VARIOUS_PAYMENT}`,
    DISCLOSURE_OF_DESIGNATED_EMPLOYEES: `/${URL.STATUTORY_DISCLOSURE}/${URL.DISCLOSURE_OF_DESIGNATED_EMPLOYEES}`,
    DISCLOSURE_OF_VARIOUS_PURPOSE: `/${URL.STATUTORY_DISCLOSURE}/${URL.DISCLOSURE_OF_VARIOUS_PURPOSE}`,
    REPORT_OF_COMPLIANCE_STEWARDSHIP_CODE: `/${URL.STATUTORY_DISCLOSURE}/${URL.REPORT_OF_COMPLIANCE_STEWARDSHIP_CODE}`,
    RATIONAL_FOR_DEVIATION: `/${URL.STATUTORY_DISCLOSURE}/${URL.RATIONAL_FOR_DEVIATION}`,
    ANNUAL_DISCLOSURE_OF_RISKOMETERS: `/${URL.STATUTORY_DISCLOSURE}/${URL.ANNUAL_DISCLOSURE_OF_RISKOMETERS}`,
    ANNUAL_REPORT: `/${URL.STATUTORY_DISCLOSURE}/${URL.ANNUAL_REPORT}`,
    ABRIDGED: `/${URL.STATUTORY_DISCLOSURE}/${URL.ABRIDGED}`,
    SCHEME_FINANCIALS: `/${URL.STATUTORY_DISCLOSURE}/${URL.SCHEME_FINANCIALS}`,
    MONTHLY_PORTFOLIO: `/${URL.STATUTORY_DISCLOSURE}/${URL.MONTHLY_PORTFOLIO}`,
    AVERAGE_PORTFOLIO: `/${URL.STATUTORY_DISCLOSURE}/${URL.AVERAGE_PORTFOLIO}`,
    AUM: `/${URL.STATUTORY_DISCLOSURE}/${URL.AUM}`,
    TRADE: `/${URL.STATUTORY_DISCLOSURE}/${URL.TRADE}`,
    COMISSION: `/${URL.STATUTORY_DISCLOSURE}/${URL.COMISSION}`,
    STAT_UNCLAIMED_DIVIDEND_REDEMPTION: `/${URL.STATUTORY_DISCLOSURE}/${URL.STAT_UNCLAIMED_DIVIDEND_REDEMPTION}`,
    TOTAL_EXPENSE_RATIO_OF_MUTUAL_FUND_SCHEMES: `/${URL.STATUTORY_DISCLOSURE}/${URL.TOTAL_EXPENSE_RATIO_OF_MUTUAL_FUND_SCHEMES}`,
    STAT_TRACKING_ERROR: `/${URL.STATUTORY_DISCLOSURE}/${URL.STAT_TRACKING_ERROR}`,
    VOTING: `/${URL.STATUTORY_DISCLOSURE}/${URL.VOTING}`,
    STEWARDSHIP_REPORT: `/${URL.STATUTORY_DISCLOSURE}/${URL.STEWARDSHIP_REPORT}`,
    REMUNERATION_NEW: `/${URL.STATUTORY_DISCLOSURE}/${URL.REMUNERATION_NEW}`,
    SCHEME_PERFORMANCE_NEW: `/${URL.STATUTORY_DISCLOSURE}/${URL.SCHEME_PERFORMANCE_NEW}`,
    INVESTOR_COMPLAINTS: `/${URL.STATUTORY_DISCLOSURE}/${URL.INVESTOR_COMPLAINTS}`,
    INVESTOR_COMPLAINTS_PMS: `/${URL.STATUTORY_DISCLOSURE}/${URL.INVESTOR_COMPLAINTS_PMS}`,
    STATUTORY_COMPLAINTS: `/${URL.STATUTORY_DISCLOSURE}/${URL.STATUTORY_COMPLAINTS}`,
    LETTER_UNITHOLDER: `/${URL.STATUTORY_DISCLOSURE}/${URL.LETTER_UNITHOLDER}`,
    STAT_PUBLIC_CAUTION_NOTICE: `/${URL.STATUTORY_DISCLOSURE}/${URL.STAT_PUBLIC_CAUTION_NOTICE}`,
    OFFER_DOCUMENT: `/${URL.STATUTORY_DISCLOSURE}/${URL.OFFER_DOCUMENT}`,
    ADVISORY_DISCLOSURE: `/${URL.STATUTORY_DISCLOSURE}/${URL.ADVISORY_DISCLOSURE}`,
    DISTRIBUTOR_COMMISSION: `/${URL.STATUTORY_DISCLOSURE}/${URL.DISTRIBUTOR_COMMISSION}`,
    MARKET_MAKERS: `/${URL.STATUTORY_DISCLOSURE}/${URL.MARKET_MAKERS}`,
    DISCLOSURENEW : `/${URL.STATUTORY_DISCLOSURE}/${URL.DISCLOSURENEW}`,
    RISK_ADJUSTED_RETURN: `/${URL.STATUTORY_DISCLOSURE}/${URL.RISK_ADJUSTED_RETURN}`,
    REPORT_ON_MISSELLING: `/${URL.STATUTORY_DISCLOSURE}/${URL.REPORT_ON_MISSELLING}`,
    STATUTORY_INFORMATION_DETAIL: `/statutory-disclosure/:informationType`,
    //StatutoryDisclosure end
    //Distributor Corner Start
    DISTRIBUTOR_CORNER: `/${URL.DISTRIBUTOR_CORNER}`,
    BEING_A_MFD: `/${URL.DISTRIBUTOR_CORNER}/${URL.BEING_A_MFD}`,
    ONBOARD_DIGITALLY: `/${URL.DISTRIBUTOR_CORNER}/${URL.ONBOARD_DIGITALLY}`,
    FORMS_DISCLOSURE: `/${URL.DISTRIBUTOR_CORNER}/${URL.FORMS_DISCLOSURE}`,
    KNOWLEDGE_CENTER: `/${URL.DISTRIBUTOR_CORNER}/${URL.KNOWLEDGE_CENTER}`,
    FAQS: `/${URL.DISTRIBUTOR_CORNER}/${URL.FAQS}`,
    SEBI_CODE_OF_CONDUCT: `/${URL.DISTRIBUTOR_CORNER}/${URL.SEBI_CODE_OF_CONDUCT}`,
    HANDBOOK: `/${URL.DISTRIBUTOR_CORNER}/${URL.HANDBOOK}`,
    DISTRIBUTOR_INFORMATION_DETAIL: `/distributor-corner/:informationType`,
    //Distrbutor Corner End
    //Start Investor Services
    INVESTOR_SERVICES: `/${URL.INVESTOR_SERVICES}`,
    FORM_AND_DISCLOSURES: `/${URL.INVESTOR_SERVICES}/${URL.FORM_AND_DISCLOSURES}`,
    OUR_ONLINE_SERVICES: `/${URL.INVESTOR_SERVICES}/${URL.OUR_ONLINE_SERVICES}`,
    ADDITIONAL_FUND_INFO: `/${URL.INVESTOR_SERVICES}/${URL.ADDITIONAL_FUND_INFO}`,
    FACTSHEETS: `/${URL.INVESTOR_SERVICES}/${URL.FACTSHEETS}`,
    FUND_DOCUMENTS: `/${URL.INVESTOR_SERVICES}/${URL.FUND_DOCUMENTS}`,
    FUND_LITERATURES: `/${URL.INVESTOR_SERVICES}/${URL.FUND_LITERATURES}`,
    INVESTOR_MARKET_UPDATE: `/${URL.INVESTOR_SERVICES}/${URL.INVESTOR_MARKET_UPDATE}`,
    INVESTOR_MARKET_UPDATE_TABS: `/investor-services/market-update/:tabType`,
    INVESTOR_MARKET_VIDEO_DETAIL: `/investor-services/market-update/videos/:informationType`,
    INVESTOR_FAQ: `/${URL.INVESTOR_SERVICES}/${URL.INVESTOR_FAQ}`,
    SCHEME_COLLECTION: `/${URL.INVESTOR_SERVICES}/${URL.SCHEME_COLLECTION}`,
    WEEKLY_PORTFOLIO_DETAILS: `/${URL.INVESTOR_SERVICES}/${URL.WEEKLY_PORTFOLIO_DETAILS}`,
    INVESTOR_INFORMATION_DETAIL: `/investor-services/:informationType`,
    //End Investor Services
    //Knowledge Stack start
    KNOWLEDGE_STACK: `/${URL.KNOWLEDGE_STACK}`,
    NEW_MD_INSIGHTS: `/${URL.KNOWLEDGE_STACK}/${URL.NEW_MD_INSIGHTS}/:informationType`,
    // MD_SPEAKS_ARTICLES: `/${URL.KNOWLEDGE_STACK}/${URL.NEW_MD_INSIGHTS}/${URL.MD_SPEAKS_ARTICLES}`,
    MDSPEAK_ARTICLE_DETAILINFO: `/knowledge-stack/md-ceo-desk/articles/:informationType`,
    // MD_SPEAKS_VIDEOS: `/${URL.KNOWLEDGE_STACK}/${URL.NEW_MD_INSIGHTS}/${URL.MD_SPEAKS_VIDEOS}`,
    MD_SPEAKS_VIDEOS_DETAILS: `/knowledge-stack/md-ceo-desk/videos/:informationType`,
    // MD_MEDIA_ARTICLES: `/${URL.KNOWLEDGE_STACK}/${URL.NEW_MD_INSIGHTS}/${URL.MD_MEDIA_ARTICLES}`,
    // MD_MEDIA_VIDEOS: `/${URL.KNOWLEDGE_STACK}/${URL.NEW_MD_INSIGHTS}/${URL.MD_MEDIA_VIDEOS}`,
    // MD_MEDIA_VIDEOS_DETAILS: `/knowledge-stack/md-ceo-desk/media/video/:informationType`,
    MARKET_REVIEW: `/${URL.KNOWLEDGE_STACK}/${URL.MARKET_REVIEW}`,
    CREDIT_POLICY: `/${URL.KNOWLEDGE_STACK}/${URL.CREDIT_POLICY}`,
    CREDITPOLICY_DETAILINFO: '/knowledge-stack/macro-insights/monetary-policy-review/:informationType',
    MF_YEARBOOK: `/${URL.KNOWLEDGE_STACK}/${URL.MF_YEARBOOK}`,
    TUESDAYS_TALKING_POINTS: `/${URL.KNOWLEDGE_STACK}/${URL.TUESDAYS_TALKING_POINTS}`,
    TALKING_DETAILINFO: '/knowledge-stack/deep-dives/tuesdays-talking-points/:informationType',
    CHART_SCOPE: `/${URL.KNOWLEDGE_STACK}/${URL.CHART_SCOPE}`,
    MF_INSIGHTS: `/${URL.KNOWLEDGE_STACK}/${URL.MF_INSIGHTS}`,
    WEEKEND_BYTES: `/${URL.KNOWLEDGE_STACK}/${URL.WEEKEND_BYTES}`,
    WEEKEND_DETAILINFO: '/knowledge-stack/mf-vault/weekend-bytes/:informationType',
    MUSINGS: `/${URL.KNOWLEDGE_STACK}/${URL.MUSINGS}`,
    MONTHLY_DETAILINFO: '/knowledge-stack/mf-vault/musings/:informationType',
    SALES_HANDBOOK: `/knowledge-stack/finance-360/:informationType`,
    WEBINARS: `/${URL.KNOWLEDGE_STACK}/${URL.WEBINARS}`,
    VIDEOS_MEDIA: `/${URL.KNOWLEDGE_STACK}/${URL.VIDEOS_MEDIA}`,
    PODCASTS_MEDIA: `/${URL.KNOWLEDGE_STACK}/${URL.PODCASTS_MEDIA}`,
    BEHAVIOURAL_BLOGS: `/${URL.KNOWLEDGE_STACK}/${URL.BEHAVIOURAL_BLOGS}`,
    BEHAVIOURAL_BLOG_DETAILINFO: `/knowledge-stack/behavioural-blogs/:informationType`,
    MARKET_REVIEW_DETAILINFO: '/knowledge-stack/macro-insights/market-review/:informationType',
    //Knowledge Stack end
    //goal marketing start
    GOAL_MARKETING: `/${URL.GOAL_MARKETING}`,
    //goal marketing end
    //IAP Page Start
    IAP_PAGE: `/learners-corner/:informationType`,
    //IAP Page End
    HOMEPAGE: `/${URL.HOMEPAGE}`,
    GOALS: `/${URL.GOALS}`,
    KNOW_YOUR_INVESTMENT_PERSONALITY: `/${URL.KNOW_YOUR_INVESTMENT_PERSONALITY}`,
    ACCOUNT_STATEMENT: `/${URL.ACCOUNT_STATEMENT}`,
    INVESTMENT_BASKET: `/${URL.PRODUCT_SOLUTIONS}/${URL.INVESTMENT_BASKET}`,
    SIP_LANDING: `/${URL.LEARN}/${URL.SIP_LANDING}`,
    //glossary start
    GLOSSARY_SEC: `/${URL.GLOSSARY_SEC}`,
    //glossary end
    //IAP WOMEN start
    IAP_WOMEN_ENGLISH: `/${URL.IAP_WOMEN_ENGLISH}`,
    EMAIL_MODAL: `/${URL.EMAIL_MODAL}`,
    EMAIL_MODAL_EVENTS: `/${URL.EMAIL_MODAL}/events`,
    EMAIL_MODAL_HINDI: `/${URL.EMAIL_MODAL}/hi`,
    IAP_REGISTRATION: `/${URL.IAP_WOMEN_ENGLISH}/${URL.IAP_REGISTRATION}`,
    IAP_QUIZ_REGISTRATION: `/${URL.IAP_QUIZ_REGISTRATION}/${URL.IAP_WOMEN_ENGLISH}`,
    //IAP WOMEN end
    // Survey Start
    FINANCIAL_TRANSACTION: `/${URL.FINANCIAL_TRANSACTION}/:value`,
    NON_FINANCIAL_TRANSACTION: `/${URL.NON_FINANCIAL_TRANSACTION}/:value`,  
    PARTNER_SURVEY: `/${URL.PARTNER_SURVEY}/:value`,
    // Survey End
    // Jan Nivesh Start
    JAN_NIVESH: `/${URL.JAN_NIVESH}`,
    // Jan Nivesh End
    // Important Announcement start
    IMMPORTANT_ANNOUNCEMENT: `/${URL.IMMPORTANT_ANNOUNCEMENT}`,
    // Important Announcement end
    //youtubeshorts start
    YOUTUBE_SHORTS: `/${URL.YOUTUBE_SHORTS}/:value`,
    //youtubeshorts end
    //OneSpan start
    ONESPAN: `/${URL.ONESPAN}`,
    ONESPANIOS: `/${URL.ONESPANIOS}`
    //OneSpan end
};
